import './style.scss';

interface AchievementPopupProps {
  title: string;
  description?: string;
  image?: string;
  position: number;
  total: number;
  onClose: () => void;
}

export function AchievementPopup({
  title,
  description,
  image,
  position,
  total,
  onClose,
}: AchievementPopupProps) {
  return (
    <div className="achievement-popup-overlay" role="dialog" aria-modal="true" aria-label="Nova conquista desbloqueada">
      <div className="achievement-popup">
        <button
          type="button"
          className="achievement-popup__close"
          onClick={onClose}
          aria-label="Fechar feedback de conquista"
        >
          ×
        </button>

        {total > 1 && (
          <span className="achievement-popup__counter">
            {position}/{total}
          </span>
        )}

        <div className="achievement-popup__content">
          <div className="achievement-popup__image-wrapper">
            {image ? (
              <img src={image} alt="Badge conquistado" className="achievement-popup__image" />
            ) : (
              <div className="achievement-popup__image achievement-popup__image--fallback" aria-hidden="true">
                🏅
              </div>
            )}
          </div>

          <span className="achievement-popup__label">Parabéns, você conquistou um novo badge!</span>
          <h2 className="achievement-popup__title">{title}</h2>
          {description ? <p className="achievement-popup__description">{description}</p> : null}
        </div>
      </div>
    </div>
  );
}
